/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
export const SET_NOT_FOUND = '@@globalError/SET_NOT_FOUND';
export const CLEAR_NOT_FOUND = '@@globalError/CLEAR_NOT_FOUND';

const initialState = { notFound: false };

export default function globalErrorReducer(state = initialState, action) {
  switch (action.type) {
    case SET_NOT_FOUND:
      return state.notFound ? state : { ...state, notFound: true };
    case CLEAR_NOT_FOUND:
      return state.notFound ? { ...state, notFound: false } : state;
    default:
      return state;
  }
}
